import translations from './const/ru.json';

const ru = {
  translation: {
    ...translations
  }
};

export default ru;